export default "__VITE_ASSET__DY8Iwhqd__"